import { TypedController } from "@vytant/stimulus-decorators";
import { Controller } from "@hotwired/stimulus";
import { IntegrationAppClient } from "@integration-app/sdk";

@TypedController
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", (event) => {
      try {
        const token = (this.element as HTMLElement).dataset.tokenUrl;

        const integrationApp = new IntegrationAppClient({
          token,
        });

        integrationApp.open();
      } catch (error) {
        console.error("Error Integration app:", error);
      }
    });
  }
}
